import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  class: "form-group"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "form-group" }

import * as ko from 'knockout';
    import { FIELD_TYPES } from 'Core/Constant';
    import { IControl } from 'Core/Controls/IControl';
    import { reactive, ref, watch, nextTick, onMounted, onBeforeUnmount } from 'vue';
    import { LayoutOptions } from './GridLayoutProperty';
    import { TranslationFieldEditor } from 'Core/Components/TranslationFieldEditor/TranslationFieldEditor';
    import { TranslationManager } from 'Core/Components/Translation/TranslationManager';
    import { ITranslationValue } from 'Core/Components/TranslationFieldEditor/ITranslationValue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'GridLayoutProperty',
  props: /*@__PURE__*/_mergeModels({
    control: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

    const props = __props;

    const model = _useModel<LayoutOptions>(__props, "modelValue");

    const layouts: Array<{ value: string; label: string }> = [
        { value: 'MidCards', label: 'Mid Cards' },
        { value: 'SmallCards', label: 'Small Cards' },
        { value: 'FilesView', label: 'Files View' },
    ];

    const controlFields = props.control.GetModel().Fields;

    const getFields = (typeNames: string[]) =>
        controlFields
            .filter((field) => typeNames.includes(field.FieldTypeName))
            .map((field) => `${field.EntityName}.${field.Name}`);

    const pictureFields = getFields([FIELD_TYPES.Image]);
    const labelFields = getFields([FIELD_TYPES.Text]);
    const priceFields = getFields([FIELD_TYPES.Decimal]);
    const subtitleTextFields = getFields([FIELD_TYPES.Text, FIELD_TYPES.Alias]);
    const subtitleLookupFields = getFields([FIELD_TYPES.Lookup]);
    const documentsFields = getFields([FIELD_TYPES.Document]);

    const layoutOptions = reactive<LayoutOptions>({
        name: model.value?.name || null,
        documentField: model.value?.documentField || '',
        pictureField: model.value?.pictureField || '',
        labelField: model.value?.labelField || '',
        priceField: model.value?.priceField || '',
        subtitleField1: model.value?.subtitleField1 || '',
        subtitleField2: model.value?.subtitleField2 || '',
        subtitleField3: model.value?.subtitleField3 || '',
        subtitleText1: model.value?.subtitleText1 || {},
        subtitleText2: model.value?.subtitleText2 || {},
        subtitleText3: model.value?.subtitleText3 || {},
    });

    // Subtitle translation editor refs and instances
    const subtitleText1El = ref<HTMLElement | null>(null);
    const subtitleText2El = ref<HTMLElement | null>(null);
    const subtitleText3El = ref<HTMLElement | null>(null);
    let subtitleEditors: TranslationFieldEditor[] = [];

    function toTranslationValues(hash: Record<string, string>): ITranslationValue[] {
        return Object.entries(hash || {}).map(([shortName, value]) => {
            const lang = TranslationManager.Instance.GetLanguageByShortName(shortName);
            return { LanguageId: lang?.Id ?? 0, Value: value };
        });
    }

    function toHash(translations: ITranslationValue[]): Record<string, string> {
        const hash: Record<string, string> = {};
        translations.forEach((t) => {
            const lang = TranslationManager.Instance.GetLanguageById(t.LanguageId);
            if (lang) hash[lang.ShortName] = t.Value;
        });
        return hash;
    }

    async function initSubtitleEditors() {
        if (subtitleEditors.length > 0) return;

        await nextTick();

        const configs = [
            { el: subtitleText1El.value, key: 'subtitleText1' as const },
            { el: subtitleText2El.value, key: 'subtitleText2' as const },
            { el: subtitleText3El.value, key: 'subtitleText3' as const },
        ];

        configs.forEach(({ el, key }) => {
            if (!el) return;

            const editor = new TranslationFieldEditor();
            editor.PopUpMode = true;
            editor.SetTranslationMaxSize(80);
            editor.LoadTranslationItems();

            const defaultLang = TranslationManager.Instance.GetDefaultLanguage();
            const defaultVal = layoutOptions[key]?.[defaultLang.ShortName] || '';
            editor.SetTranslations(toTranslationValues(layoutOptions[key]), defaultVal);

            // Proxy observable for direct input binding (Text control pattern)
            const proxyValue = ko.observable(editor.ActiveTranslation?.Value() || '');
            (editor as any)._proxyValue = proxyValue;

            // User types → sync to active translation item
            proxyValue.subscribe((newValue) => {
                editor.SetValue(newValue);
            });

            // User selects language in dropdown → update proxy with new language's value
            editor.On('TranslationSelected', editor, (eventArgs) => {
                proxyValue(eventArgs.data.Value);
            });

            // Any translation change → sync hash to layoutOptions
            editor.On('TranslationChanged', editor, () => {
                layoutOptions[key] = toHash(editor.GetTranslations(true));
            });

            ko.applyBindings(editor, el);
            editor.TranslationPopUpInit(el);
            subtitleEditors.push(editor);
        });
    }

    function cleanupSubtitleEditors() {
        subtitleEditors.forEach((editor) => {
            editor.CleanTranslationPopUp();
            editor.Cleanup();
        });
        subtitleEditors = [];
    }

    // Clear irrelevant fields when layout type changes + manage subtitle editors
    watch(() => layoutOptions.name, (name, oldName) => {
        if (name === 'FilesView') {
            layoutOptions.pictureField = '';
            layoutOptions.labelField = '';
            layoutOptions.priceField = '';
            layoutOptions.subtitleField1 = '';
            layoutOptions.subtitleField2 = '';
            layoutOptions.subtitleField3 = '';
            layoutOptions.subtitleText1 = {};
            layoutOptions.subtitleText2 = {};
            layoutOptions.subtitleText3 = {};
        }

        if (name === 'MidCards') {
            layoutOptions.subtitleField1 = '';
            layoutOptions.subtitleField2 = '';
            layoutOptions.subtitleField3 = '';
            layoutOptions.subtitleText1 = {};
            layoutOptions.subtitleText2 = {};
            layoutOptions.subtitleText3 = {};
        }

        if (name === 'SmallCards' && oldName !== 'SmallCards') {
            initSubtitleEditors();
        } else if (name !== 'SmallCards' && oldName === 'SmallCards') {
            cleanupSubtitleEditors();
        }
    });

    // Sync to parent model on any change
    watch(layoutOptions, (options) => {
        model.value = { ...options };
    }, { immediate: true, deep: true });

    // Initialize subtitle editors if already SmallCards on mount
    onMounted(() => {
        if (layoutOptions.name === 'SmallCards') {
            initSubtitleEditors();
        }
    });

    onBeforeUnmount(() => {
        cleanupSubtitleEditors();
    });

    const isMidlCards = (entry: LayoutOptions) => entry.name === 'MidCards';

    const isSmallCards = (entry: LayoutOptions) => entry.name === 'SmallCards';

    const isFilesView = (entry: LayoutOptions) => entry.name === 'FilesView';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[8] || (_cache[8] = _createElementVNode("span", null, "Visualisation", -1 /* CACHED */)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((layoutOptions.name) = $event)),
        class: "form-control"
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(layouts, (option) => {
          return _createElementVNode("option", {
            key: option.value,
            value: option.value
          }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_2)
        }), 64 /* STABLE_FRAGMENT */))
      ], 512 /* NEED_PATCH */), [
        [_vModelSelect, layoutOptions.name]
      ])
    ]),
    (isFilesView(layoutOptions))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("span", null, "Document", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((layoutOptions.documentField) = $event)),
            class: "form-control"
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("option", { value: "" }, "Select...", -1 /* CACHED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(documentsFields), (field) => {
              return (_openBlock(), _createElementBlock("option", {
                key: field,
                value: field
              }, _toDisplayString(field), 9 /* TEXT, PROPS */, _hoisted_4))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */), [
            [_vModelSelect, layoutOptions.documentField]
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (isSmallCards(layoutOptions) || isMidlCards(layoutOptions))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _cache[12] || (_cache[12] = _createElementVNode("span", null, "Picture", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((layoutOptions.pictureField) = $event)),
              class: "form-control"
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("option", { value: "" }, "Select...", -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pictureFields), (field) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: field,
                  value: field
                }, _toDisplayString(field), 9 /* TEXT, PROPS */, _hoisted_6))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, layoutOptions.pictureField]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[14] || (_cache[14] = _createElementVNode("span", null, "Label", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((layoutOptions.labelField) = $event)),
              class: "form-control"
            }, [
              _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, "Select...", -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(labelFields), (field) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: field,
                  value: field
                }, _toDisplayString(field), 9 /* TEXT, PROPS */, _hoisted_8))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, layoutOptions.labelField]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[16] || (_cache[16] = _createElementVNode("span", null, "Price", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((layoutOptions.priceField) = $event)),
              class: "form-control"
            }, [
              _cache[15] || (_cache[15] = _createElementVNode("option", { value: "" }, "Select...", -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(priceFields), (field) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: field,
                  value: field
                }, _toDisplayString(field), 9 /* TEXT, PROPS */, _hoisted_10))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, layoutOptions.priceField]
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (isSmallCards(layoutOptions))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_11, [
            _cache[18] || (_cache[18] = _createElementVNode("span", null, "Subtitle Field 1", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((layoutOptions.subtitleField1) = $event)),
              class: "form-control"
            }, [
              _cache[17] || (_cache[17] = _createElementVNode("option", { value: "" }, "Select...", -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subtitleTextFields), (field) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: field,
                  value: field
                }, _toDisplayString(field), 9 /* TEXT, PROPS */, _hoisted_12))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, layoutOptions.subtitleField1]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[20] || (_cache[20] = _createElementVNode("span", null, "Subtitle Field 2", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((layoutOptions.subtitleField2) = $event)),
              class: "form-control"
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("option", { value: "" }, "Select...", -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subtitleLookupFields), (field) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: field,
                  value: field
                }, _toDisplayString(field), 9 /* TEXT, PROPS */, _hoisted_14))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, layoutOptions.subtitleField2]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[22] || (_cache[22] = _createElementVNode("span", null, "Subtitle Field 3", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((layoutOptions.subtitleField3) = $event)),
              class: "form-control"
            }, [
              _cache[21] || (_cache[21] = _createElementVNode("option", { value: "" }, "Select...", -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subtitleLookupFields), (field) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: field,
                  value: field
                }, _toDisplayString(field), 9 /* TEXT, PROPS */, _hoisted_16))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, layoutOptions.subtitleField3]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[24] || (_cache[24] = _createElementVNode("span", null, "Subtitle Text 1", -1 /* CACHED */)),
            _createElementVNode("div", {
              ref_key: "subtitleText1El",
              ref: subtitleText1El
            }, [...(_cache[23] || (_cache[23] = [
              _createStaticVNode("<div class=\"sps-input\"><input type=\"text\" class=\"sps-input\" maxlength=\"80\" data-bind=\"textInput: _proxyValue\"><a class=\"sps-avatar size-5 -me-1.5 outline-1 padding-3px rounded-full translation-list\" data-bind=\"click: TranslationPopUpToggle\"><div data-bind=\"with: _activeTranslationItem\"><div class=\"sps-avatar-image\" data-bind=\"visible: Language.Flag\"><img class=\"object-cover\" data-bind=\"attr: {src: Language.Flag, alt: Language.Name}\" height=\"20\"></div><span class=\"sps-avatar-fallback truncate text-2xs\" data-bind=\"visible: !Language.Flag, text: Language.ShortName\"></span></div></a></div>", 1)
            ]))], 512 /* NEED_PATCH */)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[26] || (_cache[26] = _createElementVNode("span", null, "Subtitle Text 2", -1 /* CACHED */)),
            _createElementVNode("div", {
              ref_key: "subtitleText2El",
              ref: subtitleText2El
            }, [...(_cache[25] || (_cache[25] = [
              _createStaticVNode("<div class=\"sps-input\"><input type=\"text\" class=\"sps-input\" maxlength=\"80\" data-bind=\"textInput: _proxyValue\"><a class=\"sps-avatar size-5 -me-1.5 outline-1 padding-3px rounded-full translation-list\" data-bind=\"click: TranslationPopUpToggle\"><div data-bind=\"with: _activeTranslationItem\"><div class=\"sps-avatar-image\" data-bind=\"visible: Language.Flag\"><img class=\"object-cover\" data-bind=\"attr: {src: Language.Flag, alt: Language.Name}\" height=\"20\"></div><span class=\"sps-avatar-fallback truncate text-2xs\" data-bind=\"visible: !Language.Flag, text: Language.ShortName\"></span></div></a></div>", 1)
            ]))], 512 /* NEED_PATCH */)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[28] || (_cache[28] = _createElementVNode("span", null, "Subtitle Text 3", -1 /* CACHED */)),
            _createElementVNode("div", {
              ref_key: "subtitleText3El",
              ref: subtitleText3El
            }, [...(_cache[27] || (_cache[27] = [
              _createStaticVNode("<div class=\"sps-input\"><input type=\"text\" class=\"sps-input\" maxlength=\"80\" data-bind=\"textInput: _proxyValue\"><a class=\"sps-avatar size-5 -me-1.5 outline-1 padding-3px rounded-full translation-list\" data-bind=\"click: TranslationPopUpToggle\"><div data-bind=\"with: _activeTranslationItem\"><div class=\"sps-avatar-image\" data-bind=\"visible: Language.Flag\"><img class=\"object-cover\" data-bind=\"attr: {src: Language.Flag, alt: Language.Name}\" height=\"20\"></div><span class=\"sps-avatar-fallback truncate text-2xs\" data-bind=\"visible: !Language.Flag, text: Language.ShortName\"></span></div></a></div>", 1)
            ]))], 512 /* NEED_PATCH */)
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})